import { webUrlToString } from "./webUrl"

import type { WebUrl } from "./webUrl"

/**
 * Opens a URL in a new tab using secure anchor semantics.
 * @param url - URL string or WebUrl object to open
 */
export function openTab(url: WebUrl | string): void {
  const anchor = document.createElement("a")
  anchor.href = typeof url === "string" ? url : webUrlToString(url)
  anchor.target = "_blank"
  anchor.rel = "noopener noreferrer"
  anchor.click()
}
